import { Table, Card, Input, Button, Space, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useState } from 'react';

const { Search } = Input;

const DataTable = ({
  columns,
  dataSource,
  loading = false,
  pagination,
  onSearch,
  onRefresh,
  extraActions,
  rowKey = 'id',
  title,
  searchPlaceholder = 'Search...',
  scroll,
  showSerial = true,
  onChange,
  tableLayout,
}) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (value) => {
    setSearchValue(value);
    if (onSearch) { onSearch(value); }
  };

  const currentPage = pagination?.current || 1;
  const pageSize    = pagination?.pageSize || 10;

  const serialColumn = {
    title: '#',
    key: '_serial',
    width: 56,
    align: 'center',
    render: (_, __, index) => (
      <span style={{ color: 'var(--wl-text-muted)', fontSize: 12, fontWeight: 500 }}>
        {(currentPage - 1) * pageSize + index + 1}
      </span>
    ),
  };

  const finalColumns = showSerial ? [serialColumn, ...columns] : columns;

  // Only render the card header when there is something meaningful to show
  const hasHeader = title || onSearch || onRefresh || extraActions;

  const headerExtra = (onSearch || onRefresh || extraActions) ? (
    <Space>
      {onSearch && (
        <Search
          placeholder={searchPlaceholder}
          onSearch={handleSearch}
          onChange={(e) => { if (!e.target.value) { handleSearch(''); } }}
          style={{ width: 240 }}
          allowClear
        />
      )}
      {onRefresh && (
        <Tooltip title="Refresh">
          <Button icon={<ReloadOutlined />} onClick={onRefresh} />
        </Tooltip>
      )}
      {extraActions}
    </Space>
  ) : null;

  return (
    <Card
      title={hasHeader ? title : undefined}
      extra={hasHeader ? headerExtra : undefined}
      styles={{
        header: hasHeader ? undefined : { display: 'none' },
        body: { padding: 0 },
      }}
    >
      <Table
        rowKey={rowKey}
        columns={finalColumns}
        dataSource={dataSource}
        loading={loading}
        pagination={pagination ? {
          ...pagination,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          pageSizeOptions: ['10', '20', '50'],
          style: { padding: '12px 16px' },
        } : false}
        onChange={onChange}
        scroll={scroll || { x: 'max-content' }}
        tableLayout={tableLayout}
        size="middle"
      />
    </Card>
  );
};

export default DataTable;
